import styled from 'styled-components'
import Img from 'gatsby-image'

const AboutContainer = styled.div`
  background: ${({ theme }) => theme.color.ui2};
  padding: ${({ theme }) => theme.ws.padding};
  position: relative;
  overflow: hidden;
`

const AboutWrapper = styled.div`
  position: relative;
  overflow: hidden;
  display: grid;
  grid-gap: ${(props) => props.theme.ws.padding};
  justify-content: center;
  align-items: center;
  @media (${(props) => props.theme.mq.mobile}) {
    grid-template-rows: auto auto;
  }
  @media (${(props) => props.theme.mq.desktop}) {
    grid-template-columns: 1fr 2fr;
  }
`

const AboutLogoImgBg = styled.div`
  width: 256px;
  justify-self: center;
  position: absolute;
  top: -50px;
  left: -50px;
  opacity: 0.05;
  transform: rotate(20deg);
  filter: grayscale(100%);
  /* display: block;
  @media (${(props) => props.theme.mq.desktop}) {
    display: none;
  } */
`

const AboutText = styled.p`
  line-height: 24px;
  text-align: justify;
  display: inline-block;
  margin: 0;
  :not(:last-child) {
    margin-bottom: 10px;
  }
`

const AboutInfo = styled.div`
  flex-grow: 2;
  display: flex;
  flex-direction: column;
`

const AboutLogoImg = styled(Img)`
  width: 128px;
  justify-self: center;
  /* display: none;
  @media (${(props) => props.theme.mq.desktop}) {
    display: block;
  } */
`

const AboutData = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  grid-gap: 10px;
`

const AboutDataInfoWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.color.text1};
  text-decoration: none;
  background: ${({ theme }) => theme.color.ui3};
  padding: ${({ padded }) => (padded ? '5px 10px' : 0)};
`

const AboutDataInfoText = styled.span`
  margin-left: 5px;
  width: 100%;
  text-align: center;
`

const AboutDataInfoLink = styled.a`
  margin-left: 5px;
  width: 100%;
  text-align: center;
  color: inherit;
  text-decoration: none;
`

export {
  AboutContainer,
  AboutWrapper,
  AboutLogoImgBg,
  AboutText,
  AboutInfo,
  AboutLogoImg,
  AboutData,
  AboutDataInfoWrapper,
  AboutDataInfoText,
  AboutDataInfoLink,
}
